import { Component, ViewChild, forwardRef } from '@angular/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';

@Component({
  selector: 'fe-pay-method-modal',
  templateUrl: './pay-method-modal.component.html',
  styleUrls: ['./pay-method-modal.component.scss']
})
export class PayMethodModalComponent {
   @ViewChild('swal') swal!: SwalComponent;

  public fire(): void {
    this.swal.fire();
  }

}
